/* BeeMax line tour (sections/bmx-tour.liquid): deal the cards in when a line comes into view, and keep the chip of the
   line on screen marked (also when the lines stack). Without this script everything is simply visible. */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.__bmxTour) return;
    root.__bmxTour = true;
    var panels = Array.prototype.slice.call(root.querySelectorAll('.bmx-tour__panel'));
    if (!panels.length) return;
    var chips = Array.prototype.slice.call(root.querySelectorAll('.bmx-tour__chip'));
    var nav = root.querySelector('.bmx-tour__nav');
    var bar = root.querySelector('.bmx-tour__chips');
    var byId = {};
    chips.forEach(function (c) { byId[c.getAttribute('href').slice(1)] = c; });
    var current = '';
    root.classList.add('js-on');

    function reveal(p) { p.classList.add('is-in'); }
    if ('IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); seen.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.18 });
      panels.forEach(function (p) { seen.observe(p); });
    }

    function setActive(id) {
      if (id === current || !chips.length) return;
      current = id;
      chips.forEach(function (c) { c.removeAttribute('aria-current'); });
      var on = byId[id];
      if (!on) return;
      on.setAttribute('aria-current', 'true');
      if (bar && bar.scrollWidth > bar.clientWidth) {
        var l = on.offsetLeft - (bar.clientWidth - on.offsetWidth) / 2;
        try { bar.scrollTo({ left: Math.max(0, l), behavior: 'smooth' }); } catch (e) { bar.scrollLeft = Math.max(0, l); }
      }
    }

    // One cheap pass on scroll: reveal lines that are on screen (in case the observer is late) and mark the chip of the
    // last line whose top has reached the chips. That is the line you see, also when the lines stack.
    var waiting = false;
    function check() {
      waiting = false;
      var vh = window.innerHeight;
      var line = (nav ? nav.getBoundingClientRect().bottom : 0) + 48;
      var cur = '';
      panels.forEach(function (p) {
        var r = p.getBoundingClientRect();
        if (!p.classList.contains('is-in') && r.top < vh * 0.85 && r.bottom > 0) reveal(p);
        if (r.top <= line) cur = p.id;
      });
      var last = panels[panels.length - 1].getBoundingClientRect();
      if (last.bottom < line) cur = '';
      setActive(cur);
    }
    // Arrow buttons: shown when a line has more cards than fit; each click moves the cards by about one screenful.
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    panels.forEach(function (p) {
      var row = p.querySelector('.bmx-tour__row');
      var box = p.querySelector('.bmx-tour__arrows');
      if (!row || !box) return;
      var prev = box.querySelector('[data-dir="-1"]');
      var next = box.querySelector('[data-dir="1"]');
      function upd() {
        var more = row.scrollWidth > row.clientWidth + 4;
        box.hidden = !more;
        if (prev) prev.disabled = row.scrollLeft < 4;
        if (next) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      }
      function step() {
        var tile = row.querySelector('.bmx-tour__tile');
        var w = tile ? tile.offsetWidth + (parseFloat(getComputedStyle(row).columnGap) || 14) : row.clientWidth * 0.8;
        return Math.max(w, Math.floor(row.clientWidth / w) * w);
      }
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-dir]');
        if (!b || b.disabled) return;
        var d = Number(b.getAttribute('data-dir')) * step();
        try { row.scrollBy({ left: d, behavior: calm ? 'auto' : 'smooth' }); } catch (err) { row.scrollLeft += d; }
      });
      var t = 0;
      row.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(upd, 60); }, { passive: true });
      window.addEventListener('resize', upd);
      window.addEventListener('load', upd);
      upd();
    });

    window.addEventListener('scroll', function () { if (!waiting) { waiting = true; setTimeout(check, 60); } }, { passive: true });
    window.addEventListener('resize', function () { setTimeout(check, 60); });
    check();
  }
  function boot() { document.querySelectorAll('[data-bmx-tour]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-bmx-tour]'); if (r) init(r); });
})();
